/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
author: ideehochzwei (https://sketchfab.com/ideehochzwei)
license: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
source: https://sketchfab.com/3d-models/plane-aa001f5a88f64b16b98356c042f2d5f3
title: Plane
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export function PlaneModel({ ...props }) {
  const group = useRef();
  const { nodes, materials } = useGLTF("../assets/models/plane/scene.gltf");

  const x = 0;
  const y = 0;
  const z = 0;

  return (
    <group ref={group} {...props} dispose={null}>
      <group
        position={[-0.2, 0, 0.48]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={1.09}>
        <group rotation={[Math.PI / 2, 0, 0]}>
          <group rotation={[0, 0.41, 0]} scale={1.67}>
            <group scale={2.2}>
              <mesh
                position={[x, y, z]}
                castShadow
                receiveShadow
                geometry={nodes.Object_5.geometry}
                material={materials.White}
              />
              <mesh
                position={[x, y, z]}
                castShadow
                receiveShadow
                geometry={nodes.Object_6.geometry}
                material={materials.material}
              />
              <mesh
                position={[x, y, z]}
                castShadow
                receiveShadow
                geometry={nodes.Object_7.geometry}
                material={materials.Green_Gras}
              />
              <mesh
                position={[x, y, z]}
                castShadow
                receiveShadow
                geometry={nodes.Object_8.geometry}
                material={materials.Black}
              />
              <mesh
                position={[x, y, z]}
                castShadow
                receiveShadow
                geometry={nodes.Object_9.geometry}
                material={materials["ND-SOB"]}
              />
            </group>
            <group position={[-1.2, 0.71, 0]} scale={2.22}>
              <mesh
                position={[x, y, z]}
                castShadow
                receiveShadow
                geometry={nodes.Object_11.geometry}
                material={materials.White}
              />
              position={[x, y, z]}
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.Object_12.geometry}
                material={materials.material}
              />
            </group>
          </group>
        </group>
      </group>
    </group>
  );
}

useGLTF.preload("../assets/models/plane/scene.gltf");
